import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

const LANGUAGES = [
  { code: 'fr', label: 'FR' },
  { code: 'en', label: 'EN' }
];

const LanguageSwitcher = ({ collapsed = false }) => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language?.substring(0, 2) || 'fr';

  const handleChange = (langCode) => {
    i18n.changeLanguage(langCode);
  };

  if (collapsed) {
    return (
      <button
        className="sidebar-footer-btn"
        onClick={() => handleChange(currentLang === 'fr' ? 'en' : 'fr')}
        title={currentLang === 'fr' ? 'English' : 'Français'}
      >
        <Globe size={20} />
      </button>
    );
  }

  return (
    <div className="d-flex align-items-center gap-1">
      {LANGUAGES.map((lang) => (
        <button
          key={lang.code}
          className="sidebar-footer-btn"
          onClick={() => handleChange(lang.code)}
          title={lang.code === 'fr' ? 'Français' : 'English'}
          style={{
            fontWeight: currentLang === lang.code ? 700 : 400,
            opacity: currentLang === lang.code ? 1 : 0.5,
            fontSize: '0.75rem',
            minWidth: '28px'
          }}
        >
          {lang.label}
        </button>
      ))}
    </div>
  );
};

export default LanguageSwitcher;
